import React from "react";
import { ProductType } from "../../swagger-clients/s365-dashboard-v2-api-clients.service";

type ProductTypeProps = {
    productType?: ProductType;
}

export const ProductTypeDisplay: React.FC<ProductTypeProps> = ({ productType }) => {
    if (productType === undefined) return <>-</>;

    switch (productType) {
        case ProductType.DwsimPro:
            return <>DWSIM Pro</>;
        case ProductType.DwsimCollaboraton:
            return <>DWSIM Collaboration</>;
        case ProductType.FlowsheetCopilot:
            return <>Flowsheet Copilot</>;
        case ProductType.DwsimSecure:
            return <>DWSIM Secure</>;
        default:
            return <>-</>;
    }
}
